/*eslint-disable*/ export const messages = JSON.parse("{\"toast.aria.error\":[\"Fejl\"],\"toast.aria.successful\":[\"Fuldført\"],\"toast.aria.warning\":[\"Advarsel\"]}");
//# sourceMappingURL=messages.mjs.map